import datepicker from 'js-datepicker';
import {getDutchFormat, stringIsValidDate} from '@/utils/dateHelper';
import {getCustomValidationMessage} from '@/utils/customValidationMessages';

const regexYYYYMMDD = /^[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[01])/;

/**
 * @param {HTMLInputElement} input
 * @param {'min'|'max'|'value'} attr
 * @return {Date | null}
 */
const getDateFromAttribute = (input, attr) => {
	const value = input.getAttribute(attr);

	if (value.match(regexYYYYMMDD) && !isNaN(Date.parse(value))) {
		return new Date(value);
	}

	return null;
};

export const initDatepicker = () => {
	/**
	 * @type {NodeListOf<HTMLInputElement>}
	 */
	const inputs = document.querySelectorAll('input.js-datepicker');
	const datepickerActiveClass = 'datepicker-active';

	inputs.forEach((input) => {
		const inputId = input.id;

		const datepickerButtonSelector = `[id="${inputId}"] ~ button`;

		const picker = datepicker(datepickerButtonSelector, {
			onShow: (instance) => {
				instance.el.parentNode.classList.add(datepickerActiveClass);
				instance.el.parentNode.parentNode.classList.add(datepickerActiveClass);

				const valueRevertedToNormal = input.value.split('-').reverse().join('-');
				const valueAsDate = new Date(valueRevertedToNormal);

				const valueIsAValidDate = stringIsValidDate(valueRevertedToNormal);

				if (!valueIsAValidDate) {
					return;
				}
				instance.navigate(valueAsDate, true);

				if (instance.minDate && valueAsDate < instance.minDate) {
					instance.navigate(instance.minDate, true);
					return;
				}

				if (instance.maxDate && valueAsDate > instance.maxDate) {
					instance.navigate(instance.maxDate, true);
					return;
				}

				instance.setDate(valueAsDate);

			},
			onSelect: (instance, date) => {
				input.value = getDutchFormat(date);
				input.dispatchEvent(new Event('input', {bubbles: true}));
			},
			onHide: (instance) => {
				instance.el.parentNode.classList.remove(datepickerActiveClass);
				instance.el.parentNode.parentNode.classList.remove(datepickerActiveClass);
			},

			showAllDates: true,
			minDate: getDateFromAttribute(input, 'min'),
			maxDate: getDateFromAttribute(input, 'max'),
			position: 'br',

			// Localisation
			startDay: 1,
			customMonths: [
				'januari',
				'februari',
				'maart',
				'april',
				'mei',
				'juni',
				'juli',
				'augustus',
				'september',
				'october',
				'november',
				'december'
			],
			customDays: [
				'zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'
			],
			overlayButton: 'Toon jaar',
			overlayPlaceholder: 'Voer 4 cijferig jaartal in'
		});

		document.querySelector(datepickerButtonSelector).addEventListener('click', (event) => {
			event.preventDefault();
			event.stopPropagation();
			picker.show();
		});

		input.addEventListener('input', () => {
			const value = input.value;
			const SEPERATOR = '-';
			const lastChar = value.slice(-1);

			const lastCharIsNumber = !isNaN(parseInt(lastChar));

			if (value.length === 3 && lastChar !== SEPERATOR) {
				input.value = `${value.slice(0, 2)}${SEPERATOR}${lastCharIsNumber ? lastChar : ''}`;
			}
			if (value.length === 6 && lastChar !== SEPERATOR) {
				input.value = `${value.slice(0, 5)}${SEPERATOR}${lastCharIsNumber ? lastChar : ''}`;
			}

			input.setCustomValidity(getCustomValidationMessage(input));
		});

		if (input.getAttribute('type') === 'date') {
			input.setAttribute('type', 'text');
		}
	});
};
